import { render, staticRenderFns } from "./contractDetails_Basics.vue?vue&type=template&id=337d55e8"
import script from "./contractDetails_Basics.vue?vue&type=script&lang=js"
export * from "./contractDetails_Basics.vue?vue&type=script&lang=js"
import style0 from "./contractDetails_Basics.vue?vue&type=style&index=0&id=337d55e8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports